import {
  AuditEvent,
  EventDetailsBuilder,
  Metadata,
} from '@eppendorf/vnls-audit-event-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { fetcher } from '$shared/fetch';
import { AUDIT_LOGS_BASE_PATH } from '$shared/utils/api-paths';

export const auditLogQueryKey = 'audit-logs';

type AuditEventType<T extends Metadata = Metadata> =
  | Omit<AuditEvent<T>, 'id'>
  | EventDetailsBuilder;

export const useCommitAuditEvent = () => {
  const commitAuditEvent = (event: AuditEventType) =>
    fetcher.post<AuditEventType, void>(AUDIT_LOGS_BASE_PATH, event);

  const queryClient = useQueryClient();
  return useMutation<AxiosResponse<void>, AxiosError, AuditEventType>({
    mutationFn: commitAuditEvent,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [auditLogQueryKey] });
    },
  });
};
